<button
  type="button"
  #toggleFilterButton
  (click)="handleAsideButtonDisplayClick()"
  [title]="
    !asideOpenOnSmallerViewports()
      ? ('pia.features.product-series-details.productSeriesDetailsAside.openAsideButtonLabel'
        | translate)
      : ('pia.features.product-series-details.productSeriesDetailsAside.closeAsideButtonLabel'
        | translate)
  "
  [ngClass]="{ 'adaptive-aside-toggle': true }"
>
  @if (asideOpenOnSmallerViewports()) {
    <claas-icon
      [iconId]="'648425'"
      [namespace]="'pia'"
      [size]="24"
      [alt]="''"
      [removeDefaultColor]="true"
    >
    </claas-icon>
  } @else {
    <claas-icon
      [iconId]="'648420'"
      [namespace]="'pia'"
      [size]="24"
      [alt]="''"
      [removeDefaultColor]="true"
    >
    </claas-icon>
  }
</button>

<aside
  [ngClass]="{
    'product-detail-aside': true,
    'font-m': true,
    show: asideOpenOnSmallerViewports(),
  }"
>
  <div class="close-button-wrap">
    <button
      type="button"
      (click)="handleAsideButtonDisplayClick(false)"
      [title]="
        'pia.features.product-overview.productFamilyAside.closeFilterButtonLabel'
          | translate
      "
      class="close-button icon-only-button"
    >
      <claas-icon
        [iconId]="'006172'"
        [namespace]="'pia'"
        [size]="24"
        [alt]="''"
        [removeDefaultColor]="true"
      ></claas-icon>
    </button>
  </div>

  <details [open]="isDocumentsExpanded" class="accordion">
    <summary class="accordion-summary">
      <span>Documents</span>
      <claas-icon
        class="arrow-icon"
        [iconId]="'659460'"
        [namespace]="'pia'"
        [size]="24"
        [alt]="''"
        [removeDefaultColor]="true"
      >
      </claas-icon>
    </summary>
    <div class="accordion-content">
      @for (item of productDocumentCategories() || []; track item.ID) {
        <a
          [routerLink]="['./documents', item.ID]"
          routerLinkActive="link-active"
          class="content-link font-m"
          >{{ item.Title }}</a
        >
      }
    </div>
  </details>

  <details [open]="isProductsExpanded" class="accordion">
    <summary class="accordion-summary">
      <span>Products</span>
      <claas-icon
        class="arrow-icon"
        [iconId]="'659460'"
        [namespace]="'pia'"
        [size]="24"
        [alt]="''"
        [removeDefaultColor]="true"
      >
      </claas-icon>
    </summary>
    <div class="accordion-content">
      @for (descendant of productDescendants() || []; track descendant.ID) {
        @if (descendant && descendant.ID) {
          <a
            [routerLink]="['./arguments', descendant.ID]"
            [class.link-active]="activeDescendantId() === descendant.ID"
            class="content-link font-m"
            >{{ descendant.Name }}</a
          >
        }
      }
    </div>
  </details>

  <div class="pictures-link-wrapper">
    <a
      [routerLink]="['./pictures']"
      routerLinkActive="link-active"
      class="font-m pictures-link"
      >Pictures</a
    >
  </div>
</aside>
